// All products related apis
import instance, { BASEURL } from "./api";
import { encryptData } from "../helpers/encryptDecrypt";

const API_URL = BASEURL + "/api/products";

// Post api for updating an existing product's details
export const updateProduct = async (id, product) => {
  const pId = encryptData(id);
  return await instance.post(`${API_URL}/${pId}`, product, {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Post api for creating a new product for the active organization
export const addProduct = async (formData) => {
  return await instance.post(`${API_URL}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Post api for creating products in bulk for the active organization
export const addBulkProducts = async (productsData) => {
  return await instance.post(
    `${BASEURL}/api/bulk-create/products`,
    productsData
  );
};

// Delete api for deleting the existing product
export const deleteProduct = async (id) => {
  const pId = encryptData(id);
  return await instance.delete(`${API_URL}/${pId}`);
};

// Post api for deleting existing products in bulk
export const deleteMultipleProducts = async (data) => {
  return await instance.post(`${BASEURL}/api/delete-multiple-products`, data);
};

// Get api for fetching products for organization
export const fetchProductsByOrganization = async (organizationId) => {
  const oId = encryptData(organizationId);
  return await instance.get(
    `${BASEURL}/api/all-products?organization_id=${oId}`
  );
};

// Get api for fetching products for organization
export const fetchLatestProductsByOrganization = async (
  organizationId,
  date
) => {
  const oId = encryptData(organizationId);
  return await instance.get(
    `${BASEURL}/api/latest-products?organization_id=${oId}&date=${date}`
  );
};

// Get api for fetching products with filter and pagination options
export const fetchProductsByOrganizationAndBranch = async (
  organizationId,
  branchId,
  keyword,
  category,
  page,
  limit,
  sort,
  sortBy
) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);
  const encodedKeyword = keyword ? encodeURIComponent(keyword) : "";
  return await instance.get(
    `${API_URL}?organization_id=${oId}&branch_id=${bId}&keyword=${encodedKeyword}&category=${category}&page=${page}&limit=${limit}&sort_by=${sortBy}&sort=${sort}`
  );
};

// Get api for fetching products worth for active organization and branch
export const fetchProductsWorthByOrganizationAndBranch = async (
  organizationId,
  branchId
) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);
  return await instance.get(
    `${API_URL}/worth?organization_id=${oId}&branch_id=${bId}`
  );
};

// Get api for fetching products activity with product ID
export const fetchProductActivities = async (productId, branchId) => {
  const pId = encryptData(productId);
  const bId = encryptData(branchId);
  return await instance.get(`${API_URL}-activities/${pId}/${bId}`);
};
